module.exports = __webpack_public_path__ + "static/media/check-dark.9f18d1b0.svg";